import { useTranslation } from "react-i18next";
import { LocaleSwitcher } from "@/components/LocaleSwitcher";

export default function Health() {
  const { t } = useTranslation();

  return (
    <main className="hero-dot-pattern relative flex min-h-screen flex-col items-center justify-center px-6 py-8">
      <div className="absolute end-4 top-4">
        <LocaleSwitcher />
      </div>

      <div className="glass relative w-full max-w-xl rounded-2xl border border-border/60 px-8 py-12 text-center shadow-xl">
        <h1 className="text-gradient text-4xl font-bold tracking-tight sm:text-5xl">
          {t("health.title")}
        </h1>
        <p className="mt-6 text-base text-muted-foreground sm:text-lg">
          {t("health.subtitle")}
        </p>
      </div>
    </main>
  );
}
